<template>
  <AgGridWrapper
    ref="agGrid"
    title="Subscriptions (read)"
    :options="gridOptions"
    @selectedRows="$emit('select', $event)"
  />
</template>

<script>
import { priceWithCurrencyRenderer } from '@/lib/generic.utils'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  data: () => ({
    rowData: []
  }),

  computed: {
    gridOptions() {
      return {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        domLayout: 'normal',
        pagination: false,
        defaultColDef: {
          floatingFilter: true,
          filter: 'agTextColumnFilter'
        },
        rowData: this.rowData,
        columnDefs: [
          {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: 'Subscription',
            field: 'name'
          },

          {
            headerName: 'Normalized Price (USD)',
            field: 'normalized_price',
            cellRenderer: params => {
              if (!params.data) return
              params.value = params.data.normalized_price
              return priceWithCurrencyRenderer(params)
            },
            headerClass: 'price-column',
            cellStyle: { textAlign: 'right' },
            maxWidth: 100
          }
        ]
      }
    }
  },

  methods: {
    showLoading() {
      // access from parent
      this.$refs.agGrid.setLoading(true)
    },

    setNewRows(rows) {
      this.rowData = rows.map(row => ({ ...row, preselected: true }))
      this.$refs.agGrid.updateSelectedRows()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

tableWithCheckBoxes()

>>> .table-content {
  height calc(100% - 55px)
  padding 0 40px

  .ag-theme-material {
    height  100%
  }

  .ag-center-cols-viewport {
    overflow-x hidden
  }
}
</style>
